import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-homethree-video',
    templateUrl: './homethree-video.component.html',
    styleUrls: ['./homethree-video.component.scss']
})
export class HomethreeVideoComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}

    // Video Popup
    isOpen = false;
    openPopup(): void {
        this.isOpen = true;
    }
    closePopup(): void {
        this.isOpen = false;
    }

}